The current status of the underlying process.

For example, a candidate in an application process may progress through a series of statuses like applied, interviewed, offered, hired.
